<template>
  <div class="flex gap-2 flex-row justify-between items-center w-full">
    <div class="flex gap-3 align-center items-center">
      <div
        :class="[
          'flex items-center justify-center w-6 h-6 rounded-full border font-normal text-base leading-6 text-center',
          isStep1Active
            ? 'border-green-500 bg-green-500 text-white'
            : 'border-black text-[var(--text-button-primary,#FFF)]',
        ]"
      >
        1
      </div>
      <div>Coach Info</div>
    </div>
    <div class="w-6 h-px bg-gray-200"></div>
    <div class="flex gap-3 align-center items-center">
      <div
        :class="[
          'flex items-center justify-center w-6 h-6 rounded-full border font-normal text-base leading-6 text-center',
          isStep2Active
            ? 'border-green-500 bg-green-500 text-white'
            : 'border-black text-[var(--text-button-primary,#FFF)]',
        ]"
      >
        2
      </div>
      <div>First Build</div>
    </div>
    <div class="w-6 h-px bg-gray-200"></div>
    <div class="flex gap-3 align-center items-center">
      <div
        :class="[
          'flex items-center justify-center w-6 h-6 rounded-full border font-normal text-base leading-6 text-center',
          isStep3Active
            ? 'border-green-500 bg-green-500 text-white'
            : 'border-black text-[var(--text-button-primary,#FFF)]',
        ]"
      >
        3
      </div>
      <div>Get the App</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import getters from '../../stores/login-store/getters/login-getters';

  export default {
    name: 'progress-bar',
    computed: {
      ...mapState(['selectedStep', 'urlParam', 'trialAmount', 'superOrg']),
      isStep1Active() {
        return this.selectedStep === getters.SIGN_UP_COACH_INFO();
      },
      isStep2Active() {
        return this.selectedStep === getters.SIGN_UP_BUILD_SELECTION();
      },
      isStep3Active() {
        return this.selectedStep === getters.SIGN_UP_DOWNLOAD_APP() ||
               this.selectedStep === getters.SIGN_UP_EXTRA_INFO() ||
               this.selectedStep === getters.SEND_YOUR_PHONE();
      },
    },
  };
</script>
